import React from 'react';
import { SimpleShowLayout, useResourceContext } from 'react-admin';
import Heading from 'components/Heading';
import MoneyField from 'components/MoneyField';

type MinimumWageSectionProps = {
  settingsField: string;
};

export const MinimumWageSection = ({ settingsField }: MinimumWageSectionProps) => {
  const resource = useResourceContext();
  return (
    <SimpleShowLayout spacing={0} sx={{ padding: 0, marginBottom: 3 }}>
      <Heading>Minimum Wage</Heading>
      <MoneyField label="RN Minimum Wage" source={`${settingsField}.rn_minimum_wage_cents`} />
      <MoneyField label="LVN Minimum Wage" source={`${settingsField}.lvn_minimum_wage_cents`} />
      <MoneyField
        label="Allied Minimum Wage"
        source={`${settingsField}.allied_minimum_wage_cents`}
      />
      {resource === 'StateRateSetting' && (
        <MoneyField label="W2 Minimum Wage" source={`${settingsField}.w2_minimum_wage_cents`} />
      )}
    </SimpleShowLayout>
  );
};
